import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 64 64" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <rect fill={color} height="30" rx="4" width="30" x="17" y="17"/>
        <path fill={color} d="M3 18a2 2 0 0 0 2-2V7.828l7.586 7.586a2 2 0 0 0 2.828-2.828L7.828 5H16a2 2 0 0 0 0-4H3a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2zM61 1H48a2 2 0 0 0 0 4h8.172l-7.586 7.586a2 2 0 1 0 2.828 2.828L59 7.828V16a2 2 0 0 0 4 0V3a2 2 0 0 0-2-2zM16 59H7.828l7.586-7.586a2 2 0 0 0-2.828-2.828L5 56.172V48a2 2 0 0 0-4 0v13a2 2 0 0 0 2 2h13a2 2 0 0 0 0-4zM61 46a2 2 0 0 0-2 2v8.172l-7.586-7.586a2 2 0 0 0-2.828 2.828L56.172 59H48a2 2 0 0 0 0 4h13a2 2 0 0 0 2-2V48a2 2 0 0 0-2-2z"/>
    </svg>
)

export default class IconFit extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
